
import React from 'react';
import { Task } from '@/types/task';
import { TaskCard } from './TaskCard';

interface TaskColumnProps {
  day: string;
  tasks: Task[];
  isToday?: boolean;
  isAdmin: boolean;
  onComplete: (task: Task) => void;
  onDelete: (taskId: string) => void;
  onEdit: (taskId: string, data: any) => void;
  onReactivate?: (task: Task) => void;
}

export const TaskColumn = ({ 
  day, 
  tasks, 
  isToday,
  isAdmin,
  onComplete,
  onDelete,
  onEdit,
  onReactivate
}: TaskColumnProps) => {
  return (
    <div className="w-full flex flex-col">
      <h2 className="w-full text-xl font-semibold text-gray-800 sticky top-0 bg-white/90 p-2 rounded mb-4">
        {isToday ? `Today (${day})` : day}
      </h2>
      <div className="w-full flex-1 overflow-y-auto px-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        {tasks.length > 0 ? (
          tasks.map(task => (
            <TaskCard
              key={task.id}
              task={task}
              isAdmin={isAdmin}
              onComplete={onComplete}
              onDelete={onDelete}
              onEdit={onEdit}
              onReactivate={onReactivate}
            />
          ))
        ) : (
          <p className="text-gray-500 text-sm italic">No tasks for {day}</p>
        )}
      </div>
    </div>
  );
};
